import { render, staticRenderFns } from "./jiucuo.vue?vue&type=template&id=99b20d6c&scoped=true&"
import script from "./jiucuo.vue?vue&type=script&lang=js&"
export * from "./jiucuo.vue?vue&type=script&lang=js&"
import style0 from "./jiucuo.vue?vue&type=style&index=0&id=99b20d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b20d6c",
  null
  
)

export default component.exports